import { SharedUtilitiesConfig } from "@payping/utilities-shared/config";

SharedUtilitiesConfig.setConfig({ baseUrl: process.env.REACT_APP_DOMAIN });
